<template>
  <div id="app">
    <block-header id="header" v-on="block_handlers" />
    <block-main v-on="block_handlers" />
    <block-advantages v-on="block_handlers" />
    <block-countdown v-on="block_handlers" />
    <block-cars id="cars" v-on="block_handlers" />
    <!-- <block-stock v-on="block_handlers" /> -->
    <block-promotions v-on="block_handlers" />
    <block-credit id="credit" v-on="block_handlers" />
    <block-contacts id="contacts" v-on="block_handlers" />
    <block-footer />
    <block-legal v-on="block_handlers"/>

    <full-get
      v-show="show.get"
      @close="closeThings"
      v-on="block_handlers"
      :custom_text="data.text"
    >
    </full-get>
    <full-agreement v-show="show.agreement" @close="closeAgreement" />
    <full-thanks v-if="show.thanks" @close="show.thanks = false" />
    <preloader v-if="show.load" />
  </div>
</template>

<script>
import BlockHeader from "./components/block-header";
import BlockMain from "./components/block-main";
import BlockCountdown from "./components/block-countdown.vue";
import BlockUndermain from "./components/block-undermain";
import BlockAdvantages from "./components/block-advantages";
import BlockCars from "./components/block-cars";
// import BlockStock from "./components/block-stock";
import BlockPromotions from "./components/block-promotions";
import BlockCredit from "./components/block-credit";
import BlockContacts from "./components/block-contacts";
import BlockLegal from "./components/block-legal";
import BlockFooter from "./components/block-footer";
import FullGet from "./components/full-get";
import FullAgreement from "./components/full-agreement";
import FullThanks from "./components/full-thanks";
import Mixin from "./common/mixin";
import Preloader from "./components/preloader";

import Send from "./common/send";

import $ from "jquery";

import smoothScrollTo from "./common/smoothScrollTo";

export default {
  name: "app",
  components: {
    BlockHeader,
    BlockAdvantages,
    BlockCountdown,
    BlockFooter,
    BlockContacts,
    BlockCredit,
    BlockCars,
    // BlockStock,
    BlockMain,
    BlockUndermain,
    FullGet,
    FullAgreement,
    FullThanks,
    BlockLegal,
    Preloader,
    BlockPromotions,
  },
  mixins: [Mixin],
  data: function () {
    return {
      show: {
        thanks: false,
        get: false,
        agreement: false,
        load: false,
      },
      data: {},
    };
  },
  mounted() {
    $("html").on("keyup", (event) => {
      if (event.keyCode === 27) {
        this.closeThings();
      }
    });

    // window.ctw_phones = [];

    if (window.location.hash === "#credit") {
      this.scrollTo("credit");
    } else if (window.location.hash.length) {
      this.scrollTo("credit");
    }
  },
  computed: {
    block_handlers() {
      return {
        getAgreement: this.handleGetAgreement,
        scrollTo: this.scrollTo,
        callBack: this.callThere,
        getCall: this.handleGetCall,
      };
    },
  },
  methods: {
    closeThings() {
      this.show.get = false;
      this.show.thanks = false;
      this.show.agreement = false;
      this.data = {};
      this.unblockScroll();
    },
    closeAgreement() {
      this.show.agreement = false;
      let has_show = false;
      for (let key in this.show) {
        if (this.show[key]) {
          has_show = true;
        }
      }
      if (!has_show) {
        this.unblockScroll();
      }
    },
    handleGetCall(data) {
      this.show.get = true;
      this.data = data;
      this.blockScroll();
    },
    handleGetAgreement() {
      this.show.agreement = true;
      this.blockScroll();
    },
    scrollTo(where) {
      smoothScrollTo(
        $("#" + where).offset().top -
          (this.device_platform === "desktop" ? 20 : 5)
      );
    },
    callThere(event) {
      const finishCall = () => {
        this.closeThings();
        this.show.load = false;
        this.show.thanks = true;
        if (typeof window.dataLayer !== "undefined") {
          window.dataLayer.push({
            event: "callkeeper-call_order-ckaction",
            eventCategory: "callkeeper",
            eventAction: "call_order",
            eventLabel: "ckaction",
          });
        }
        console.log("done");
      };

      let req = Send(event, this.data);
      this.show.load = true;
      if (!req) {
        finishCall();
      } else {
        req.finally(finishCall);
      }
    },
  },
};
</script>
